import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const steps = [
  {
    icon: "FiCoffee",
    title: "Small-Batch Prep",
    desc: "Our chefs prepare your chosen flavors in micro-batches every Thursday morning."
  },
  {
    icon: "FiThermometer",
    title: "Deep Freeze",
    desc: "We flash-freeze the pints to -40°F, locking in creamy texture and flavor integrity."
  },
  {
    icon: "FiPackage",
    title: "Dry Ice Packing",
    desc: "Your box is packed with high-grade dry ice in our recycled insulated liners."
  },
  {
    icon: "FiTruck",
    title: "Monday Shipping",
    desc: "All batches leave our facility Monday morning for a Tuesday/Wednesday arrival."
  }
];

const Process = () => {
  return (
    <section className="bg-white py-24 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-6xl font-bold mb-6">The Cold-Chain Journey</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-lg italic">
            From our kitchen to your doorstep, we've mastered the art of frozen delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 relative">
          {/* Connector Line */}
          <div className="hidden lg:block absolute top-16 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-frost-ice to-transparent z-0"></div>
          
          {steps.map((step, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="relative z-10 text-center px-4"
            >
              <div className="w-24 h-24 bg-frost-vanilla rounded-3xl flex items-center justify-center mx-auto mb-8 shadow-xl shadow-frost-ice/50 border border-frost-ice group hover:bg-frost-berry transition-colors duration-500">
                <SafeIcon icon={step.icon} className="text-4xl text-frost-berry group-hover:text-white transition-colors" />
                <div className="absolute -top-3 -right-3 w-10 h-10 bg-frost-ice rounded-full flex items-center justify-center font-bold text-frost-berry border-4 border-white">
                  {idx + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold mb-4">{step.title}</h3>
              <p className="text-gray-500 leading-relaxed text-sm">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;